export type Environment = "production" | "staging" | "local";

declare const __APP_ENV__: string | undefined;
declare const __VITE_ENVIRONMENT__: string | undefined;

type EnvironmentVariables = Record<string, string | undefined>;

function normalizeEnvironment(value: string | undefined): Environment | null {
  const normalizedValue = value?.toLowerCase().slice(0, 4);

  if (normalizedValue === "prod") return "production";
  if (normalizedValue === "stag") return "staging";
  if (normalizedValue === "loca") return "local";
  if (normalizedValue === "deve") return "local";
  if (normalizedValue === "test") return "local";

  return null;
}

function getProcessEnv(): EnvironmentVariables {
  if (typeof process === "undefined") return {};

  return {
    ...process.env,
    ENVIRONMENT: process.env.ENVIRONMENT,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
    VITE_ENVIRONMENT: process.env.VITE_ENVIRONMENT,
  };
}

function getViteEnv(): EnvironmentVariables {
  return {
    VITE_ENVIRONMENT:
      typeof __VITE_ENVIRONMENT__ === "undefined"
        ? undefined
        : __VITE_ENVIRONMENT__,
  };
}

function getEnvironmentValue(env?: EnvironmentVariables) {
  const resolvedEnv = env ?? getProcessEnv();
  const viteEnv = env ? {} : getViteEnv();

  return (
    viteEnv.VITE_ENVIRONMENT ??
    resolvedEnv.ENVIRONMENT ??
    resolvedEnv.NEXT_PUBLIC_ENVIRONMENT ??
    resolvedEnv.REACT_APP_ENVIRONMENT ??
    resolvedEnv.VITE_ENVIRONMENT ??
    (typeof __APP_ENV__ === "undefined" ? undefined : __APP_ENV__)
  );
}

export function getEnvironment(env?: EnvironmentVariables): Environment {
  return normalizeEnvironment(getEnvironmentValue(env)) ?? "local";
}

export const environment = getEnvironment();
export const isProductionEnvironment = (() =>
  getEnvironment() === "production")();
export const isStagingEnvironment = (() => getEnvironment() === "staging")();
export const isLocalEnvironment = (() => getEnvironment() === "local")();

// redeploy 2
